/** @format */

import { KeyboardBackspaceSharp } from "@mui/icons-material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";

interface CommonContainerProps {
    title: string;
    description: string;
    children: React.ReactNode;
    backButtonurl?: any;
}

const CommonContainer: React.FC<CommonContainerProps> = ({
    children,
    title,
    description,
    backButtonurl
}) => {
    const navigate = useNavigate();
    return (
        <Box p={2}>
            <Typography variant="h4" >
            {backButtonurl &&
            <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={()=> {navigate(backButtonurl)}}
                color="inherit"

            >
                <KeyboardBackspaceSharp style={{ color: "black" }} />
            </IconButton>}
                {title}
            </Typography>

            <Typography variant="body1"  sx={{marginLeft: backButtonurl? "3.5%": "0%"}}>
                {description}
            </Typography>

            <Divider sx={{ marginBottom: "1%" }} />

            {children}
        </Box>
    );
};

export default CommonContainer;
